export default __webpack_public_path__ + "static/media/contact-agency.icon.905bca85.svg";